import { sound, useSoundEnabled } from '../lib/audio';

export function SoundToggle({ variant = 'icon' }: { variant?: 'icon' | 'full' }) {
  const on = useSoundEnabled();
  return (
    <button
      type="button"
      className={variant === 'icon' ? 'icon-btn' : 'btn btn--ghost'}
      aria-pressed={on}
      aria-label={variant === 'icon' ? (on ? 'Sound on. Mute.' : 'Sound off. Unmute.') : undefined}
      title={on ? 'Mute sound' : 'Turn sound on'}
      onClick={() => sound.toggle()}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor" stroke="none" />
        {on ? (
          <>
            <path d="M16.5 8.5a5 5 0 0 1 0 7" />
            <path d="M19 6a8.5 8.5 0 0 1 0 12" />
          </>
        ) : (
          <path d="M17 9l5 6M22 9l-5 6" />
        )}
      </svg>
      {variant === 'full' && <span>{on ? 'Sound: on' : 'Sound: off'}</span>}
    </button>
  );
}
